import {
  SearchItemsResponse,
  Search,
} from './src/media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal';

export * from './src/media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';

/** @hidden */
export type EnterpriseMediaItemSearch = {};

/**
 * Searches for items using text-based search criteria.
 *
 * Search Items runs with these defaults, which you can override:
 *
 * - `paging.limit` is `50`
 * - `paging.offset` is `0`
 *
 * All filters support equality only. Each search must include a `categoryId` filter. Use this endpoint when you need to search for items by text. For retrieving items with custom sorting, use [Query Items](#queryitems).
 *
 * To learn about working with search methods, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language) and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
 * @param query - Search query for text-based matching across item `title`, `displayTags`, and `internalTags` fields. Partial matching is supported for `title` and `displayTags`. `internalTags` require a full exact match. All filters support equality only. Each query must include a `categoryId` filter.
 * @public
 * @documentationMaturity preview
 * @requiredField query
 * @permissionId MEDIA.ENTERPRISE_MEDIA_ITEMS_READ
 * @applicableIdentity APP
 * @fqn com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.SearchItems
 */
export declare function searchItems(
  query: Search
): Promise<SearchItemsResponse>;
